import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import LiteratureCoverLetter from '../../_partials/HtmlLiteratureCoverLetter';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
var LiteratureThumbHtmlView = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    return (React.createElement("div", { style: { width: width, height: height }, className: classnames('daeditor-literature-root', getThumbGlobalClassNames(deviation)) },
        React.createElement(LiteratureCoverLetter, { deviation: deviation }),
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "daeditor-literature-title" }, getDeviationTitle(deviation)),
            React.createElement("div", { className: "daeditor-literature-text" }, deviation.textContent && deviation.textContent.excerpt))));
};
LiteratureThumbHtmlView.displayName = 'LiteratureThumbHtmlView';
export default LiteratureThumbHtmlView;
//# sourceMappingURL=LiteratureHtml.js.map